/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=42229d4c&scoped=true&"
import script from "./SortableList.vue?vue&type=script&setup=true&lang=js&"
export * from "./SortableList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SortableList.vue?vue&type=style&index=0&id=42229d4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42229d4c",
  null
  
)

export default component.exports